import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Language } from '../../types';

interface Props {
  lang: Language;
}

interface Testimonial {
  name: string;
  text: {
    en: string;
    fa: string;
  };
}

const testimonials: Testimonial[] = [
  {
    name: "PanteA",
    text: {
      en: "You are a great listener and very insightful, with an ability to pinpoint the core issue and help resolve it. Our sessions helped me gain clarity, take action, and move forward, which has been truly valuable for me.",
      fa: "شنونده‌ی خوبی هستی، باهوشی و می‌تونی مسئله‌ی اصلی رو تشخیص بدی و در حلش کمک کنی. جلسات با تو به من کمک کرد بهتر ببینم، قدم بردارم و جلو برم؛ این برای من واقعاً باارزشه."
    }
  },
  {
    name: "Mahkameh",
    text: {
      en: "We identified the root of my recurring patterns regarding my career path, and this awareness has been incredibly helpful. Thank you for being such a patient, understanding, and non-judgmental companion throughout this process.",
      fa: "ما ریشه‌ی طرحواره‌های تکراری‌ام را در مسیر شغلی شناسایی کردیم و این آگاهی خیلی به من کمک کرده است. از تو ممنونم که با صبوری، درک بالا و بدون قضاوت، در این مسیر همراه و صبور بودی."
    }
  },
  {
    name: "Sahar",
    text: {
      en: "The most significant takeaway was learning to truly forgive myself and stop the self-blame over the past. You helped me align my skills and talents with a clear path toward generating income.",
      fa: "مهم‌ترین ارزش این جلسات، یادآوری این بود که خودم را بابت گذشته سرزنش نکنم و واقعاً خودم را ببخشم. تو به من کمک کردی تا توانایی‌ها و استعدادهایم را در مسیر درستِ کسب درآمد قرار دهم."
    }
  },
  {
    name: "Parham",
    text: {
      en: "My perspective on the fears that were hindering my progress has shifted. The process has helped me reduce hesitation in my decision-making and move forward with more determination.",
      fa: "دیدگاهم نسبت به ترس‌هایی که مانع کارم می‌شد تغییر کرد. روند جلسات باعث شد در تصمیماتم تردید کمتری داشته باشم و بتوانم در بلندمدت مصمم‌تر پیش بروم."
    }
  },
  {
    name: "Atousa",
    text: {
      en: "Each session left me feeling mentally and emotionally stronger. You helped me ask the right questions to clear my path. Thank you for being a light during my most challenging days.",
      fa: "هر بار از لحاظ روحی و ذهنی بهتر می‌شدم. با کمک تو سوالات جدید و مهمی برای هموار کردن راهم مطرح می‌شد. ممنونم که در روزهای سخت، برای من نوری در تاریکی بودی."
    }
  },
  {
    name: "Fereshte",
    text: {
      en: "I can now express my mental concerns more freely and feel a sense of lightness. I’ve learned to truly listen to my inner self and have gained better control over expressing my emotions.",
      fa: "الان راحت‌تر از دغدغه‌های ذهنی‌ام می‌گویم و حس سبک‌بالی پیدا می‌کنم. یاد گرفتم گوش شنوایی برای فرشته‌ی درونم باشم و مدیریت بهتری روی ابراز احساسات و هیجاناتم داشته باشم."
    }
  },
  {
    name: "Vida",
    text: {
      en: "I now pay closer attention to my inner dialogue—the very thoughts that used to hinder my growth. Our conversations helped me prioritize effectively and face realities, creating immense value.",
      fa: "با جزئیات بیشتری به صدای افکارم توجه می‌کنم؛ همان افکاری که قبلاً مانع رشدم بودند. در گفتگوهایمان اولویت‌بندی‌ها و واقعیت‌ها را بهتر مرور کردیم و ارزش‌های زیادی خلق شد."
    }
  },
  {
    name: "Pouyan",
    text: {
      en: "The results of these sessions for me were greater self-honesty, overcoming stagnation, and reconnecting with past goals. Your confidence in your expertise—stating, \"I know my craft and I know how to coach\"—is what drew me to work with you. You have a unique ability to help clients break free from past mistakes rather than staying stuck in them. Thank you for the generous time you've dedicated to me.",
      fa: "دستاورد این جلسات برای من روراستی بیشتر با خودم، پرهیز از سکون و زنده کردن اهداف گذشته بود. اعتماد به نفس شما در تخصصتان و جمله‌ای که گفتید: \"من کارم را بلدم و می‌دانم چطور کوچینگ انجام دهم\"، باعث شد مشتاق همکاری با شما شوم. شما می‌توانید عاملی موثر باشید تا مخاطب به جای گیر افتادن در اشتباهات گذشته، از آن‌ها رها شود. ممنون برای وقتی که بی‌دریغ در اختیارم گذاشتید."
    }
  },
  {
    name: "Bahar",
    text: {
      en: "Kayvan simply works magic!",
      fa: "کیوان واقعاً معجزه می‌کنه!"
    }
  },
  {
    name: "Sahar",
    text: {
      en: "I probably shouldn't say this as a therapist, but you do a better job than most therapists!",
      fa: "شاید به عنوان یک تراپیست نباید این رو بگم، اما کارت تراپی هم بهتره!"
    }
  },
  {
    name: "Alireza",
    text: {
      en: "Kayvan is an incredible listener; he helped me untie my mental knots. I felt truly understood.",
      fa: "کیوان خیلی خوب گوش میده و به من کمک کرد گره‌های ذهنیم رو باز کنم. واقعاً احساس کردم شنیده و درک شدم."
    }
  }
];

const TestimonialCard: React.FC<{ testimonial: Testimonial; lang: Language; index: number }> = ({ testimonial, lang, index }) => (
  <motion.div
    key={index}
    className="flex-none w-[80vw] md:w-[360px] bg-white rounded-xl p-6 shadow-lg shadow-black/5 border border-gray-100 snap-start hover:shadow-elevated transition-shadow duration-200"
    whileHover={{ y: -4, scale: 1.01 }}
    transition={{ type: "spring", stiffness: 400, damping: 30 }}
  >
    {/* Large decorative quote */}
    <span className="text-4xl text-primary/20 font-serif leading-none select-none">"</span>
    <p className="text-base text-gray-600 leading-relaxed mt-1 mb-4 text-pretty">
      {testimonial.text[lang]}
    </p>
    <p className="font-medium text-sm text-brandDark">
      {testimonial.name}
    </p>
  </motion.div>
);

const TestimonialsSection: React.FC<Props> = ({ lang }) => {
  const title = lang === 'en' ? 'What clients say' : 'نظر مراجعین';

  const scrollerRef = useRef<HTMLDivElement>(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);

  const updateScrollState = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    setCanScrollPrev(el.scrollLeft > 0);
    setCanScrollNext(el.scrollLeft < maxScrollLeft - 1);
  };

  useEffect(() => {
    updateScrollState();
    const el = scrollerRef.current;
    if (!el) return;
    const handleScroll = () => updateScrollState();
    el.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const scrollByAmount = (direction: 'prev' | 'next') => {
    const el = scrollerRef.current;
    if (!el) return;
    const amount = Math.max(el.clientWidth * 0.8, 320);
    el.scrollBy({ left: direction === 'next' ? amount : -amount, behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <h2 className="swiss-headline text-3xl md:text-4xl text-brandDark text-balance">
            {title}
          </h2>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollByAmount('prev')}
              aria-label={lang === 'en' ? 'Previous testimonials' : 'نظرهای قبلی'}
              disabled={!canScrollPrev}
              className="btn btn-icon disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => scrollByAmount('next')}
              aria-label={lang === 'en' ? 'Next testimonials' : 'نظرهای بعدی'}
              disabled={!canScrollNext}
              className="btn btn-icon disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div
          id="testimonials-carousel"
          ref={scrollerRef}
          className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4 scrollbar-hide"
          role="region"
          aria-label={lang === 'en' ? 'Testimonials carousel' : 'اسلایدر نظرات'}
        >
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={`testimonial-${index}`} testimonial={testimonial} lang={lang} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
